import React from "react";
import { List } from "../modules/MobileSubmission";

export function MobileSubmissionList() {
  return <List />;
}
